import isEnv from 'helpers/is/isEnv'

const isDev = isEnv('dev')

export const minPwdLength = isDev ? 3 : 8
export const maxPwdLength = 64
export const emailMinLength = 5
export const emailMaxLength = 56
export const usernameMinLength = 2
export const usernameMaxLength = 30
export const displaynameMaxLength = 50
export const descriptionMaxLength = 1024
export const roleNameMinLength = 2
export const roleNameMaxLength = 50

export const serverDisplayNameMaxLength = 100
export const serverOverviewMaxLength = 1000

export const channelNameMaxLength = 80
export const channelSlugMaxLength = 30

export const groupNameMaxLength = 80
export const groupSlugMaxLength = 30

export const userProfileLimits = {
  link: 56,
  userName: 30,
  pronouns: 20,
  displayName: displaynameMaxLength,
  description: descriptionMaxLength,
  fieldLabel: 20,
  fieldContent: 80,
  location: 200,
  timezone: 56,
}

export const limitsText = {
  short: 'Too short',
  long: 'Too long',
}
